import { Task } from "./Routine/types";
import { useRoutineEditDirty_Routine$data } from "./__generated__/useRoutineEditDirty_Routine.graphql";
import { coerceString } from "./coerceString";

function getTaskImagesKey(images: readonly { id: string }[]) {
  return images
    .map(({ id }) => id)
    .sort()
    .join("");
}

export function taskDirtyCheck(
  remoteTasks: useRoutineEditDirty_Routine$data["activeVersion"]["tasks"],
  localTasks: Task[] | undefined
) {
  if (localTasks === undefined) {
    return false;
  }

  const remoteTasksMap = new Map(remoteTasks.map((task) => [task.id, task]));
  const localTasksMap = new Map(localTasks.map((task) => [task.id, task]));

  for (const localCurrentTask of localTasks) {
    const remoteTask = remoteTasksMap.get(localCurrentTask.id);

    if (!remoteTask) {
      return true; // Added task
    }

    if (
      coerceString(localCurrentTask.title) !== coerceString(remoteTask.title) ||
      coerceString(localCurrentTask.instructions) !==
        coerceString(remoteTask.instructions) ||
      getTaskImagesKey(localCurrentTask.images ?? []) !==
        getTaskImagesKey(remoteTask.images ?? []) ||
      localCurrentTask.type !== remoteTask.__typename
    ) {
      return true;
    }

    if (
      localCurrentTask.type === "TaskCheck" &&
      remoteTask.__typename === "TaskCheck"
    ) {
      if (
        (localCurrentTask.sentiments ?? []).slice().sort().join("") !==
        (remoteTask.sentiments ?? []).slice().sort().join("")
      ) {
        return true;
      }
    }

    if (
      localCurrentTask.type === "TaskNumber" &&
      remoteTask.__typename === "TaskNumber"
    ) {
      if (localCurrentTask.unit !== remoteTask.unit) {
        return true;
      }
    }
  }

  for (const remoteTask of remoteTasks) {
    if (!localTasksMap.has(remoteTask.id)) {
      return true; // Deleted task
    }
  }

  return false;
}
